import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./State.css";
import userIcon from "../Images/conyersterrell-1.webp"; // Replace with actual profile image

const statsData = [
  {
    name: "conyersterrell",
    followers: "31.3k Followers",
    gained: "29k",
    likes: "750+",
    stats: [
      { label: "Engagement Rate Increase", value: "647%" },
      { label: "Impressions Increase", value: "169%" },
      { label: "Reach Increase", value: "96%" },
    ],
  },
  {
    name: "Hailey’s Clothing",
    followers: "24.2k Followers",
    gained: "22k",
    likes: "1.5k+",
    stats: [
      { label: "Traffic Increase", value: "737%" },
      { label: "Revenue Increase", value: "156%" },
      { label: "Customers Gained", value: "1,590" },
    ],
  },
  {
    name: "Michael's Art",
    followers: "18.7k Followers",
    gained: "15k",
    likes: "900+",
    stats: [
      { label: "Engagement Rate Increase", value: "521%" },
      { label: "Impressions Increase", value: "134%" },
      { label: "Reach Increase", value: "78%" },
    ],
  },
  {
    name: "Tech Trends",
    followers: "40.2k Followers",
    gained: "35k",
    likes: "2.1k+",
    stats: [
      { label: "Traffic Increase", value: "912%" },
      { label: "Revenue Increase", value: "240%" },
      { label: "Customers Gained", value: "2,300" },
    ],
  },
  {
    name: "Fitness Freak",
    followers: "29.1k Followers",
    gained: "27k",
    likes: "1.2k+",
    stats: [
      { label: "Engagement Rate Increase", value: "678%" },
      { label: "Impressions Increase", value: "189%" },
      { label: "Reach Increase", value: "89%" },
    ],
  },
  {
    name: "Food Lovers",
    followers: "50.6k Followers",
    gained: "45k",
    likes: "3.5k+",
    stats: [
      { label: "Traffic Increase", value: "845%" },
      { label: "Revenue Increase", value: "199%" },
      { label: "Customers Gained", value: "3,100" },
    ],
  },
];

const Stats = () => {
  return (
    <Container className="stats-container py-5">
      <Row>
        {statsData.map((item, index) => (
          <Col md={6} sm={12} key={index} className="stats-box">
            <div className="profile">
              <img src={userIcon} alt="Profile" className="profile-img2" />
              <div>
                <h4>{item.name}</h4>
                <p>{item.followers}</p>
              </div>
            </div>

            <div className="stats-details">
              <Row>
                <Col xs={6} className="stats-label">Followers Gained:</Col>
                <Col xs={6} className="stats-value">{item.gained}</Col>
                
              </Row>
              <hr/>
              <Row>
                <Col xs={6} className="stats-label">Avg. Likes/Post:</Col>
                <Col xs={6} className="stats-value">{item.likes}</Col>

              </Row>
              <hr/>
            </div>

            <div className="stats-card red-card">
              {item.stats.map((stat, idx) => (
                <Row key={idx}>
                  <Col xs={8} className="stats-label">{stat.label}</Col>
                  <Col xs={4} className="stats-value">{stat.value}</Col>
                  <hr/>
                </Row>
                
              ))}
            </div>
    
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Stats;
